import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Users, Building2, Layers, Shield } from 'lucide-react';
import { useAuth } from '../auth/AuthProvider';
import OrgMembersMembers from './OrgMembersMembers';
import OrgMembersOrg from './OrgMembersOrg';
import OrgMembersWorkspaces from './OrgMembersWorkspaces';
import NoOrgState from './NoOrgState';
import RoleManager from './RoleManager';

const TABS = [
  { id: 'members',      label: 'Members',      icon: Users },
  { id: 'organization', label: 'Organization',  icon: Building2 },
  { id: 'workspaces',   label: 'Workspaces',    icon: Layers },
  { id: 'roles',        label: 'Role Manager',  icon: Shield },
];

const OrgMembers = () => {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'members';

  const tenantId = localStorage.getItem('tenant_id') || user?.tenant_id || user?.last_active_tenant_id;

  const switchTab = (tabId) => {
    setSearchParams({ tab: tabId });
  };

  const handleOrgDeleted = () => {
    switchTab('workspaces');
  };

  return (
    <div className="p-6 space-y-6">
      {/* Page header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Organization Management</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage members, roles, and workspace settings · PRD: ADM-O / ORG-M
        </p>
      </div>

      {!tenantId ? (
        <NoOrgState />
      ) : (
        <>
          {/* Tab bar — only shown when an org is active */}
          <div className="flex border-b border-gray-700/50 mb-6">
            {TABS.map(tab => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => switchTab(tab.id)}
                  className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 transition-colors ${
                    activeTab === tab.id
                      ? 'text-cyan-400 border-cyan-400'
                      : 'text-gray-500 border-transparent hover:text-gray-300'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>

          {/* Tab content */}
          {activeTab === 'members' && <OrgMembersMembers tenantId={tenantId} />}
          {activeTab === 'organization' && <OrgMembersOrg tenantId={tenantId} onOrgDeleted={handleOrgDeleted} />}
          {activeTab === 'workspaces' && <OrgMembersWorkspaces activeTenantId={tenantId} />}
          {activeTab === 'roles' && <RoleManager />}
        </>
      )}
    </div>
  );
};

export default OrgMembers;
